import { render, staticRenderFns } from "./PlanlamaButon.vue?vue&type=template&id=c895c58a&"
import script from "./PlanlamaButon.vue?vue&type=script&lang=js&"
export * from "./PlanlamaButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports